import { useQuery } from '@tanstack/react-query';

import { fetchApisHistoryApi } from '../api';

export default function useApisHistoryQuery(params: any, options?: any) {
  return useQuery(['apis', 'history', params], fetchApisHistoryApi, options);
}
